var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditorItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90915 15.6042H0L0.365153 14.2577C0.584814 14.2577 0.949967 14.1856 1.31512 14.1856C1.75444 14.1856 1.97125 14.1136 2.19092 14.0443C2.48475 13.903 2.70156 13.7589 2.8499 13.6176C2.99539 13.4043 3.14088 13.1937 3.21505 12.9084L5.84244 2.90916C5.91661 2.62379 5.91661 2.41045 5.84244 2.26915C5.77112 2.05581 5.62278 1.91451 5.40597 1.7732C5.25763 1.70117 4.96664 1.6319 4.67566 1.55986C4.31051 1.4906 3.94536 1.41856 3.7257 1.41856L4.09085 0H13L12.6348 1.41856C12.4152 1.41856 11.8304 1.4906 11.4652 1.4906C11.1001 1.55986 10.8091 1.55986 10.5894 1.6319C10.2984 1.70117 10.0046 1.84524 9.85912 2.05581C9.71363 2.26915 9.56814 2.48248 9.56814 2.76509L6.9379 12.7671C6.86658 13.0497 6.86658 13.263 6.9379 13.4763C7.01207 13.6897 7.15756 13.831 7.37722 13.903C7.52271 13.9723 7.74237 14.0443 8.10753 14.1136C8.47268 14.1856 9.05749 14.1856 9.2743 14.2577L8.90915 15.6042Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorItalic);
export default __webpack_public_path__ + "static/media/icon_editor_italic.f2a8bcbdb44aad76290b886f39c85981.svg";
export { ForwardRef as ReactComponent };